export default __webpack_public_path__ + "static/media/safari3.1b6dfa61.jpg";